'use strict';

angular.module('ringbaPortal.services').factory('columnsFetchService', columnsFetchService);

function columnsFetchService(
  accountsService
) {
  'ngInject';

  const checkCurrentUser = {
    'affiliate': accountsService.isAffiliateOnly,
    'buyer': accountsService.isBuyerOnly,
    'admin': accountsService.isAdmin,
    'affiliate_manager': accountsService.isAffiliateManager,
    'buyer_manager': accountsService.isBuyerManager
  };

  const service = {
    getColumnList: getColumnList,
    hideForUser: hideForUser
  };

  return service;

  // Pass columnSettings to handle hiding specific columns from specific user types
  // Eg. Use - hideForUserType: ['affiliate'], in a columnSettings property to hide it from an affiliate
  // That would also hide it from the column selector dropdown.
  function getColumnList (userSettings, defaultColumns, tableName, columnSettings) {
    const columns = _getColumns(userSettings, defaultColumns, tableName);
    if (columnSettings) {
      return _.filter(columns, function(column) {
        return columnSettings[column] && (!columnSettings[column]['hideForUserType'] || !hideForUser(columnSettings[column]['hideForUserType']));
      });
    }
    return columns;
  }

  function hideForUser(userTypes) {
    let hideColumn = false;
    _.forEach(userTypes, function(type) {
      if (checkCurrentUser[type]()) {
        hideColumn = true;
        return false;
      }
    });
    return hideColumn;
  }

  function _getColumns(userSettings, defaultColumns, tableName) {
    if (userSettings[tableName] && userSettings[tableName].columns) {
      if (_columnsChanged(userSettings[tableName].columns, defaultColumns)) {
        return userSettings[tableName].columns;
      } else {
        return defaultColumns;
      }
    } else {
      return defaultColumns;
    }
  }

  function _columnsChanged (userSettingsColumns, defaultColumns) {
    let changed = false;
    if (userSettingsColumns.length !== defaultColumns.length) {
      return true;
    }
    angular.forEach(userSettingsColumns, function (column, index){
      if (defaultColumns.indexOf(column) != index) {
        changed = true;
      }
    });
    return changed;
  }

}